export const recentItemsRoutes = [
  {
    path: '/recent',
    name: 'recent-items',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "recent-items" */ './RecentItems.vue')
  }
];
